<template>
  <el-drawer
    :model-value="visible"
    :direction="drawerDirection"
    :size="drawerSize"
    :with-header="true"
    :modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    @update:model-value="handleClose"
    header-class="header"
    style="width: 80%; left: 10%; top: 10%;"
  >
    <!-- Drawer 标题 -->
    <template #header>
      <h3 class="drawer-title">Contact Us</h3>
    </template>

    <!-- Drawer 内容 -->
    <div class="drawer-content">
      <img
        src="/contact.png"
        alt="QR Code"
        class="qr-code"
      />
      <div style="margin-top: 10px;">
        Send email to: <el-text type="primary"><span style="font-size: 20px;">kingwood@global-ptt.com</span></el-text>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:visible"]); // 声明 emit 事件

const drawerSize = "50%"; // 占据屏幕高度的 0%
const drawerDirection = "ttb"; // 从上到下打开

// 处理 Drawer 关闭
const handleClose = (value) => {
  emit("update:visible", value); // 向父组件发送更新事件
};
</script>

<style scoped>
/* Drawer 标题样式 */
.header{
    margin-bottom: 0px;
}
.drawer-title {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

/* Drawer 内容样式 */
.drawer-content {
  padding: 20px;
  text-align: center;
  height: calc(40vh - 60px); /* 高度占屏幕的 30%，减去标题和 padding 的高度 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 二维码图片样式 */
.qr-code {
  width: 100%; /* 占满 Drawer 内容的 80% */
  border: 1px solid #ddd;
  border-radius: 8px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .el-drawer {
    border-radius: 0 0 10px 10px; /* 底部圆角效果 */
  }
}
</style>